module.exports = __webpack_public_path__ + "static/media/laddu_walk_back.fbf092c9.gif";